/**
 * Created by fky on 3/16/2017.
 */
'use strict';
angular.module('betosyswebapp')
  .service('errorHandlingService', function ($uibModal, $timeout, $q, $translate, toastService) {
    var modelInstance;

    this.hasJqxNotificationCreated = false;
    /**
     * Use if rest status code 400 is returned
     *
     * @param response
     */
    this.errorForNoAuthorized = function (response) {
      var errCode = 0;
      try {
        errCode = response.data.errors[0].code;
        /*jshint unused:true */
      } catch (e) {
        //intentionally do nothing
      }
      if (checkIsAuthorizedErrorCode(errCode)) {
        return true;
      }
      this.handleForCommonResponse(response);
      return false;
    };

    this.handleForCommonResponse = function (rejection) {

      // Request Timed out
      if(rejection.status === 504){
        toastService.showErrorToast({
          type: 'F',
          message: $translate.instant('errorCodes.restAPI.52504.message')
        });
        return $q.reject(rejection);
      }

      var content = '';
      if (rejection.data && rejection.data.length > 0 && rejection.status !== 401) {
        content = rejection.data[0].message;
      } else {
        if (rejection.data && rejection.data.errors && rejection.data.errors.length > 0) {
          //console.log($translate.instant('errorCodes.' + rejection.data.errors[0].code));
          if (!rejection.data.errors[0].code.match(/^[0-9]+$/)) { // check for GTS Type of error code
            content = rejection.data.message;
          } else { // non GTS Type of messages
            content = $translate.instant('errorCodes.' + rejection.data.errors[0].code);
            content = content !== 'errorCodes.' + rejection.data.errors[0].code ? content : rejection.data.message;
          }
        }
        else {
          if (rejection.data && rejection.data.message) {
            content = rejection.data.message;
          }
        }
      }
      if (content && content !== '') {
        showMessage('danger', content);
      }
      return $q.reject(rejection);
    };

    //timeout
    this.handleForUnknowResponse = function () {
      showMessage('danger', $translate.instant('errorCodes.timeout'));
    };

    this.handleForErrorNumber = function (errorNumber) {
      openModelDialog(getErrorObjectFromErrorNumber(errorNumber));

    };
    function getErrorObjectFromErrorNumber(errorNumber) {
      var _errorObj = {};
      _errorObj.errorNumber = errorNumber;
      if ($translate.instant('errorCodes.restAPI.' + errorNumber + '.message') !== 'errorCodes.restAPI.' + errorNumber + '.message') {
        _errorObj.message = $translate.instant('errorCodes.restAPI.' + errorNumber + '.message');
      }
      if ($translate.instant('errorCodes.restAPI.' + errorNumber + '.type') !== 'errorCodes.restAPI.' + errorNumber + '.type') {
        _errorObj.type = $translate.instant('errorCodes.restAPI.' + errorNumber + '.type');
      }
      if ($translate.instant('errorCodes.restAPI.' + errorNumber + '.format') !== 'errorCodes.restAPI.' + errorNumber + '.format') {
        _errorObj.format = Number($translate.instant('errorCodes.restAPI.' + errorNumber + '.format'));
      }
      return _errorObj;
    }


    /**
     * @param type message type. eg 'danger'
     * @param message
     */
    function showMessage(type, message) {
      openModelDialog({type: type, message: message});
    }


    function checkIsAuthorizedErrorCode(errorCode) {
      if(errorCode !== undefined){
        //
        var authorizeCode = ['CM0010', 'CM0011', 'CM0015', 'CM0020', 'AU0010', 'AC0020', 'AC0030', 'AC0040',
          'AC0042', 'AC0046', 'US0020'];
        for (var i = 0; i < authorizeCode.length; i++) {
          if (errorCode === authorizeCode[i]) {
            return true;
          }
        }
      }

      return false;
    }

    /**
     *
     * @param errorObject = {message: '', type: '', format; ''}
     * @returns {string}
     */
    function createTemplate(errorObject) {
      errorObject.format = errorObject.format || 0;

      return '<div class="modal-header">' +
        '<h4 class="modal-title"><i class="glyphicon ' + getMessageType(errorObject.type) + ' style="font-size: 50px;"></i> BetoTrack </h4>' +
        '</div>' +
        '<div class="modal-body">' +
        '<div>' + errorObject.message + '</div>' +
        '</div>' +
        '<div class="modal-footer">' + getButtons(errorObject.format) + '</div>';
    }

    function getMessageType(type) {
      switch (type) {
        case 'M':
          return 'glyphicon-info-sign';
        case 'W':
          return 'glyphicon-warning-sign';
        case 'F':
          return 'glyphicon-alert';
        default:
          return 'glyphicon-alert';
      }
    }


    function getButtons(format) {
      switch (format) {
        case 0:
          return '<button  class="btn btn-primary" ng-click="ok()" focus-on="true" translate="responseErrorDilaog.ok">';
        case 1:
          return '<button  class="btn btn-primary" ng-click="yes()" translate="responseErrorDilaog.yes">' +
            '<button type="button" class="btn btn-warning" ng-click="no()" translate="responseErrorDilaog.no"></button>';
        case 3:
          return '<button  class="btn btn-primary" ng-click="yes()" translate="responseErrorDilaog.yes">' +
            '<button type="button" class="btn btn-warning" ng-click="no()" translate="responseErrorDilaog.no"></button>' +
            '<button type="button" class="btn btn-warning" ng-click="cancel()" translate="responseErrorDilaog.cancel"></button>';
        default:
          return '<button  class="btn btn-primary" ng-click="ok()" translate="responseErrorDilaog.ok">';
      }
    }

    /* INTERNAL FUNCTIONS */
    /**
     *
     * @param errorObject = {message: '', type: '', format; ''}
     */

    function openModelDialog(errorObject) {
      var template = createTemplate(errorObject);
      modelInstance = $uibModal.open({
        template: template,
        controller: function ($scope, $rootScope) {

          $scope.ok = function () {
            if (errorObject.errorNumber) {
              $rootScope.$broadcast('errorEvent', {
                errorNumber: errorObject.errorNumber,
                type: 'ok'
              });
            }

            $scope.$close();
          };

          $scope.yes = function () {
            if (errorObject.errorNumber) {
              $rootScope.$broadcast('errorEvent', {
                errorNumber: errorObject.errorNumber,
                type: 'yes'
              });
            }

            $scope.$close();
          };
          $scope.no = function () {
            if (errorObject.errorNumber) {
              $rootScope.$broadcast('errorEvent', {
                errorNumber: errorObject.errorNumber,
                type: 'no'
              });
            }
            $scope.$dismiss();
          };

          $scope.cancel = function () {
            if (errorObject.errorNumber) {
              $rootScope.$broadcast('errorEvent', {
                errorNumber: errorObject.errorNumber,
                type: 'cancel'
              });
            }
            $scope.$dismiss();
          };
        }
      });

      if (errorObject.format === 5) {
        setTimeout(function () {
          modelInstance.dismiss('time out');
        }, 2000);
      }

    }

    var that = this ;
    this.showJqxNotificationInfo = function (notificationContent) {
        that.createJqxNitification();
        $('#jqx_notification_content').html(notificationContent);
        $('#jqx_notification').jqxNotification('open');
    };
    this.createJqxNitification = function () {
        if(!this.hasJqxNotificationCreated){
            $('#jqx_notification').jqxNotification({
                animationCloseDelay: 100,
                opacity: 1,
                width: 325,
                autoOpen: false,
                autoClose: false,
                appendContainer: '#jqx_notification_container',
                template: 'info'
            });
            this.hasJqxNotificationCreated = true;
        }       
    };
    this.closeJqxNotificationInfo = function() {
      // close all exsisting notification related to the view when ever localcation changes. 
      try{
        $('#jqx_notification').jqxNotification('closeAll');
      } catch(err){
          console.log(err);
      }
    };
  })
;



// WEBPACK FOOTER //
// ./.tmp/components/common/services/ErrorHandlingService.js